import { Component, OnInit } from '@angular/core';
import { LoadingService } from '../core/services/loading.service';

declare var $: any;
declare var bodymovin: any;

@Component({
    selector: 'app-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
    standalone: false
})
export class LoadingComponent implements OnInit {

  constructor(public content: LoadingService) {
    content.titulo = 'Por favor espera un momento ...';
    content.texto = 'Estamos validando tu identidad';
  }

  ngOnInit() {
  }
}